module.exports = __webpack_public_path__ + "img/gy1.1420961b.png";